export const listFreestyleClasss = `query ListFreestyleClasss(
  $filter: ModelFreestyleClassFilterInput
  $limit: Int
  $nextToken: String
) {
  listFreestyleClasss(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      group
      title
      description
      active
      type
      shared
      layoutLevel
      classPDFLink
      playlistURL
      sortOrder
      owner
      createdByUser {
        id
        firstName
        lastName
      }
    }
    nextToken
  }
}
`

export const getFreestyleClass = `query GetFreestyleClass($id: ID!) {
  getFreestyleClass(id: $id) {
    id
    group
    title
    description
    active
    type
    shared
    layoutLevel
    classPDFLink
    playlistURL
    sortOrder
    createdByUser {
      id
      firstName
      lastName
      authUsername
      active
    }
    owner
  }
}
`

export const getFreestyleClassWithSongs = `query GetFreestyleClass($id: ID!) {
  getFreestyleClass(id: $id) {
    id
    group
    title
    description
    active
    type
    shared
    layoutLevel
    classPDFLink
    playlistURL
    sortOrder
    createdByUser {
      id
      authUsername
      firstName
      lastName
    }
    freestyleSongs(limit:999) {
      items {
        id
        song
        artist
        coaching_notes
        coaching_notes_simple
        owner
        pr_a
        pr_b
        rpm_a
        rpm_b
        sortOrder
        videoURL
        actionComponent {
          id
          name
          pr_range
          rpm_high
          rpm_low
          coachingNotes
          simpleCoaching
          level
        }
      }
    }
    owner
  }
}
`
